// extracted by mini-css-extract-plugin
export default {"wrap":"TJ-z","subtitle":"UJ-z","contentWrap":"VJ-z","imgWrap":"WJ-z","heading":"XJ-z","copy":"YJ-z"};